import type { MeStats } from "../api";

export function Stats({ me, highlight }: { me: MeStats; highlight: number | null }) {
  const winPct = me.games > 0 ? Math.round((me.wins / me.games) * 100) : 0;
  const max = Math.max(1, ...me.dist);
  return (
    <div>
      <div className="grid grid-cols-4 gap-2 text-center">
        <Stat value={me.games} label="ігор" />
        <Stat value={winPct} label="% перемог" />
        <Stat value={me.streak} label="стрік 🔥" />
        <Stat value={me.maxStreak} label="рекорд" />
      </div>
      <div className="mt-4 text-xs font-semibold uppercase tracking-wide text-tghint">
        розподіл спроб
      </div>
      <div className="mt-2 space-y-1">
        {me.dist.map((n, i) => {
          const pct = Math.max(7, Math.round((n / max) * 100));
          const hot = highlight === i + 1;
          return (
            <div key={i} className="flex items-center gap-2 text-sm">
              <div className="w-3 text-right font-semibold">{i + 1}</div>
              <div className="flex-1">
                <div
                  className={`flex h-5 items-center justify-end rounded-sm px-1.5 text-xs font-bold text-white ${hot ? "bg-tile-correct" : "bg-tile-absent"}`}
                  style={{ width: `${pct}%` }}
                >
                  {n}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Stat({ value, label }: { value: number; label: string }) {
  return (
    <div>
      <div className="text-3xl font-bold leading-none">{value}</div>
      <div className="mt-1 text-[11px] leading-tight text-tghint">{label}</div>
    </div>
  );
}
